<template>
  <component
    :is="linkComponent"
    :rel="rel"
    :class="glLinkClass"
    :target="target"
    :style="{ ...fontSizeStyle }"
    :href="href">
    <slot name="fa-icon-before">
      <font-awesome-icon
        v-if="iconBeforeText"
        :icon="[faIconWeight, 'chevron-left']"
        :style="{ ...fontSizeStyle }"
        aria-hidden="true"></font-awesome-icon>
    </slot>
    <span>
      <slot>
        Click here<span class="sr-only"> to go to {{ pageName }}</span>
      </slot>
    </span>
    <slot name="fa-icon-after">
      <font-awesome-icon
        v-if="!iconBeforeText"
        :icon="[faIconWeight, 'chevron-right']"
        :style="{ ...fontSizeStyle }"
        aria-hidden="true"></font-awesome-icon>
    </slot>
  </component>
</template>
<script>
export default {
  name: "GlLink",
  props: {
    noFollow: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: Number,
      default: 1.0,
    },
    target: {
      type: String,
      default: "_self",
    },
    href: {
      type: String,
      default: null,
    },
    asDummy: {
      type: Boolean,
      default: false,
    },
    iconBeforeText: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    linkComponent () {
      return this.asDummy ? "span" : "a";
    },
    fontSizeStyle () {
      return { fontSize: `${this.fontSize}rem` };
    },
    faIconWeight () {
      return this.variant ? "fas" : "fal";
    },
    glLinkClass () {
      let result = [];
      if ( this.variant ) {
        result = [...result, "gl-btn", "btn"];

        switch ( this.variant ) {
          case 1:
            result.push( "btn-accent-1" );
            break;
          case 2:
            result.push( "btn-accent-2" );
            break;
          case 3:
            result.push( "btn-accent-3" );
            break;
          default:
            break;
        }
      } else {
        result.push( "gl-link" );
      }

      return result;
    },
    pageName () {
      let result;

      if ( this.href ) {
        const path = this.href.split( "?" )[0];
        const segments = path.split( "/" );
        result = segments[segments.length - 1];
        result = result.replace( "/%20/", " " );
        result = result.replace( "-", " " );
      }
      return result;
    },
    rel () {
      let result = "follow";

      if ( this.asDummy ) {
        result = "";
      } else if ( this.noFollow ) {
        result = "nofollow";
      }
      return result;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.gl-btn {
  > * + * {
    margin-left: 0.25rem;
  }
}

.gl-link {
  text-transform: uppercase;
  text-decoration: none;
  color: @color-accent-1;

  > * + * {
    margin-left: 0.125rem;
  }

  &:hover {
    text-decoration: none;
    color: @color-accent-1-dark;
  }

  &:focus {
    outline: 1px solid #000;
  }
}
</style>
